// extracted by mini-css-extract-plugin
export default {"container":"Address_container__dfMAa","block":"Address_block__REY09","selected":"Address_selected__aZO3e","text":"Address_text__sp5zd"};